import { TransactionsContextType } from "@zenith/context/global-context/types";
import { MastercardIcon } from "@zenith/assets/icons/components";
import { memo } from "react";
import CopyToClipboard from "@zenith/components/ui/CopyToClipboard/CopyToClipboard";
import { OperationFullDTO } from "@zenith/services/transactions";
import { shouldShow, getCardType, truncateText } from "@zenith/utils/TransactionDisplayHelpers";
import "@zenith/utils/ExtensionMethods";

export interface PosTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const PosTransactionDetails = memo(function PosTransactionDetails(
  props: PosTransactionDetailsProps
) {
  const { transaction } = props;
  const paymentMethod = transaction?.paymentMethod;
  const paymentMethodString = paymentMethod as string;
  
  const isPosOrder = 
    paymentMethod === OperationFullDTO.paymentMethod.POS_ORDER ||
    paymentMethodString === "POS_ORDER";

  const maskedPan = (transaction as any)?.maskedPan || (transaction as any)?.payerAccount?.maskedPan;
  const cardType = getCardType(maskedPan);

  return (
    <>
      {shouldShow(transaction?.beneficiaryName) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Name</p>
          <p className="font-medium text-neutral-900">
            {transaction?.beneficiaryName}
          </p>
        </div>
      )}

      {shouldShow(transaction?.bankName) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Bank</p>
          <p className="font-medium text-neutral-900">
            {transaction?.bankName}
          </p>
        </div>
      )}

      {/* {shouldShow(transaction?.beneficiaryAccountNumber) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Account</p>
          <CopyToClipboard text={transaction?.beneficiaryAccountNumber} />
        </div>
      )} */}

      {shouldShow(transaction?.description) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Description</p>
          <div className="w-80">
            <p className="text-right font-medium text-neutral-900 break-words">
              {truncateText(transaction?.description)}
            </p>
          </div>
        </div>
      )}

      {!isPosOrder && (
        <>
          <hr className="my-4 border-t-1 border-neutral-200" />
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Card Number</p>
            <div className="flex justify-between gap-1">
              <MastercardIcon transform="scale(0.7)" />
              <p className="font-medium text-neutral-900">
                {maskedPan || "•••• •••• •••• ••••"}
              </p>
            </div>
          </div>

          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Card Type</p>
            <p className="font-medium text-neutral-900">{cardType}</p>
          </div>

          {shouldShow(transaction?.sessionId) && (
            <div className="mb-2 flex justify-between">
              <p className="text-neutral-600">Session ID</p>
              <CopyToClipboard text={transaction?.sessionId} />
            </div>
          )}

          {shouldShow(transaction?.terminalId) && (
            <div className="mb-2 flex justify-between">
              <p className="text-neutral-600">Terminal ID</p>
              <p className="font-medium text-neutral-900">
                {transaction?.terminalId}
              </p>
            </div>
          )}
        </>
      )}
    </>
  );
});

export default PosTransactionDetails;